import React from "react";
import "./common.css";

const LandingFooter = () => {
  return (
    <footer className="section mt-0 footerSec">
      <div className="container">
        <div className="footerBanner move-up">
          <div className="footerBanner__text-wrapper">
            <h2>Ready to experience JIGYAASU? Simply click below to try now!</h2>
            <p>Transform your study experience with JIGYAASU's intelligent assistance and support. Dive in today!</p>
          </div>
          <div className="footerBanner__btn-wrapper">
            <a href=""><span className="text">Try Now</span>
              <span>
                <img src="./assets/images/icon-arrow-up-right.svg" alt="try now" />
              </span>
            </a>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <h2 className="section-heading2">Connect <br />With us.</h2>

            <div className="footerSec__subscribe">
              <h3>Subscribe Now</h3>

              <div className="footerSec__subscribe-input-wrapper">
                <form>
                  <input className="footerSec__subscribe-input" type="email" placeholder="Enter your email..." />
                  <button className="footerSec__subscribe-button" type="submit">Send</button>
                </form>
              </div>
            </div>

            <div className="footerSec__socialLinks">
              <a href=""><img src="./assets/images/icon-li.svg" alt="LinkedIn" /></a>
              <a href=""><img src="./assets/images/icon-discord.svg" alt="Discord" /></a>
              <a href=""><img src="./assets/images/icon-messenger.svg" alt="Messenger" /></a>
              <a href=""><img src="./assets/images/icon-tel.svg" alt="Telegram" /></a>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row footerSec__links">
              <div className="col-md-4">
                <h3>Features</h3>
                <ul>
                  <li>
                    <a href="">Aira Chat</a>
                  </li>
                  <li>
                    <a href="">Analyze</a>
                  </li>
                  <li>
                    <a href="">My Subjects</a>
                  </li>
                  <li>
                    <a href="">Test</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <h3>&nbsp;</h3>
                <ul>
                  <li>
                    <a href="">Flowchart</a>
                  </li>
                  <li>
                    <a href="">Code Practice</a>
                  </li>
                  <li>
                    <a href="">Let's Talk</a>
                  </li>
                  <li>
                    <a href="">Virtual Classroom</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <h3>Company</h3>
                <ul>
                  <li>
                    <a href="">About Us</a>
                  </li>
                  <li>
                    <a href="">Contact Us</a>
                  </li>
                  <li>
                    <a href="">FAQ</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="footerSec__separator"></div>

        <div className="row footerSec__link-row">
          <div className="col-md-6">
            <div className="footerSec__links2">
              <ul>
                <li>
                  <a href="">Terms and condition</a>
                </li>
                <li>
                  <a href="">Privacy Policy</a>
                </li>
                <li>
                  <a href="">Refund Policy</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 text-end">
            &copy; 2025 Metadee AI, All Rights Reserved.
          </div>
        </div>

        <div className="footerSec__bottom-deco move-up">

        </div>
      </div>

    </footer>
  );
};

export default LandingFooter;